import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import Loader from "@/components/Loader/LoaderView";
import Swal from "sweetalert2";
import PromoCode from "@/components/PromoCode/event_promo_code.vue";
import EventMediaGallery from "@/components/EventMediaGallery/event_media_gallery.vue";
import EventResource from "@/components/EventResource/event_resource.vue";
import EventSpeaker from "@/components/EventSpeaker/event_speaker.vue";
import EventAgenda from "@/components/EventAgenda/event_agenda.vue";
import EventSponsor from "@/components/EventSponsor/event_sponsor.vue";
import EventSurvey from "@/components/EventSurvey/event_survey.vue";

const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
import helpers from "./manage_event_helper";
import { handle_manage_event_realtime } from "@/services/eventRealtimeHandlers";

const DEFAULT_MANAGE_TAB = "basic";
const DEFAULT_ADVANCED_SECTION = "agenda";
const MANAGE_TABS = ["basic", "advanced"];
const ADVANCED_SECTIONS = [
  "agenda",
  "speakers",
  "survey",
  "photo_wall",
  "event_slides",
  "promo_codes",
  "recurring",
  "sponsors"
];

export default {
  components: {
    HomeNavBar,
    InactivityModal,
    Loader,
    PromoCode,
    EventMediaGallery,
    EventResource,
    EventSpeaker,
    EventAgenda,
    EventSponsor,
    EventSurvey,
  },
  data(){
    return({
        is_loading: true,
        event: null,
        error_message: "",
        event_id: null,
        selected_event: {},
        event_tickets: [],
        errors: {},
        portals:[],
        event_types:[],
        recurring_patterns:[],
        all_tickets:[],
        event_name: "",
        event_capacity:0,
        location: "",
        portal_id: "",
        event_type:'',
        is_recurring: false,
        organizer:'',
        event_description:'',
        end_date: "",
        end_time: '',
        rsvp_start_date: "",
        rsvp_start_time: '',
        rsvp_end_date: "",
        rsvp_end_time: '',
        start_date: "",
        start_time: '',
        is_free:true,
        public_gallery: true,
        public_slides: true,
        tickets: [],
        cover_image: null,
        cover_image_preview: null,
        latitude: null,
        longitude: null,
        map_auto_complete: null,
        map_auto_complete_input: null,
        recurring_type:'',
        date_validation_passed: true,
        ticket_show_dropdown: false,
        has_unsaved_changes: false,
        event_link:"",
        show_extras_form: false,
        extra_forms: [],
        show_add_extras: true,
        extras: [],
        active_manage_tab: DEFAULT_MANAGE_TAB,
        active_advanced_section: DEFAULT_ADVANCED_SECTION,
        photo_wall_media: [],
        event_slides_documents: [],
        event_promos: [],
  })
},
   computed: {
    total_capacity() {
      return this.tickets.reduce((s, t) => s + Number(t.quantity), 0)
    },
    potential_revenue() {
      return this.tickets.reduce((s, t) => s + Number(t.price) * Number(t.quantity), 0)
    },
    min_ticket_price() {
      return Math.min(...this.tickets.map(t => Number(t.price)))
    },
    today_date() {
      const d = new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    min_datetime() {
      const d = new Date();
      d.setSeconds(0, 0);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    },
    check_list() {
      const has_date_errors = !!(this.errors?.start_date || this.errors?.end_date || this.errors?.start_time || this.errors?.end_time);
      const has_rsvp_errors = !!(this.errors?.rsvp_start_date || this.errors?.rsvp_end_date || this.errors?.rsvp_start_time || this.errors?.rsvp_end_time);

      const has_valid_ticket = (this.tickets || []).some((t) => this.is_valid_ticket(t));
      const rsvp_start_date = this.normalize_optional_field(this.rsvp_start_date);
      const rsvp_start_time = this.normalize_optional_field(this.rsvp_start_time);
      const rsvp_end_date = this.normalize_optional_field(this.rsvp_end_date);
      const rsvp_end_time = this.normalize_optional_field(this.rsvp_end_time);
      const has_blank_rsvp_window =
        !rsvp_start_date &&
        !rsvp_start_time &&
        !rsvp_end_date &&
        !rsvp_end_time;
      const has_any_rsvp_value = !has_blank_rsvp_window;
      const has_complete_rsvp_window =
        !!rsvp_start_date &&
        !!rsvp_start_time &&
        !!rsvp_end_date &&
        !!rsvp_end_time;
      const matches_event_window =
        rsvp_start_date === this.normalize_optional_field(this.start_date) &&
        rsvp_start_time === this.normalize_optional_field(this.start_time) &&
        rsvp_end_date === this.normalize_optional_field(this.end_date) &&
        rsvp_end_time === this.normalize_optional_field(this.end_time);
      const should_show_rsvp_checklist = has_any_rsvp_value && !matches_event_window;

      return [
        { 
          label: 'Event Start Date, time & venue set', 
          done: !!this.start_date && !!this.start_time && !!this.end_date && !!this.end_time && (!!this.location || this.event_link) && !has_date_errors
        },
        ...(!this.is_free 
          ? [{ label: 'At least one ticket type', done: has_valid_ticket }] 
          : (should_show_rsvp_checklist
              ? [{
                  label: 'RSVP Start Date, time & end date, time set',
                  done: has_complete_rsvp_window && !has_rsvp_errors
                }]
              : [])
        ),
      ]
    },
    checked_count() {
      return this.check_list.filter(i => i.done).length
    },
    progress_width() {
      return (this.checked_count / this.check_list.length * 100) + '%'
    },
    speakers_preview_items() {
      return this.event?.speakers;
    },
    agenda_preview_items() {
      return this.event?.agenda;
    },
    promo_codes_preview_items() {
      return this.event.promo_codes;
    },
    photo_wall_preview_items() {
      const files = this.get_event_media_files();
      return files?.slice(0, 3);
    },
    event_slides_preview_items() {
      const files = this.get_event_resource_files();
      return files;
    },
    sponsors_preview_items() {
      return this.event.sponsors;
    },
    current_survey() {
      const survey = this.event?.survey;
      if (!survey) return null;

      const first = Array.isArray(survey) ? (survey[0] || null) : survey;
      if (!first || typeof first !== 'object') return null;

      // Some APIs return surveys as [{ survey: {...}, ...meta }]. Normalize to the survey object.
      const nested = first?.survey && typeof first.survey === 'object' ? first.survey : null;
      if (nested) {
        return ({
          ...nested,
          // Keep any top-level fields if present (e.g. survey_questions, is_answered, creator, etc.)
          ...first,
        });
      }

      return first;
    },
    has_survey() {
      return !!this.current_survey;
    },
   can_save_draft() {
   return !!this.start_date && !!this.start_time && this.date_validation_passed;
   },
   is_checklist_complete() {
     return this.check_list.length > 0 && this.check_list.every(i => i.done);
   },
  },
  mounted() {
    this.reset_manage_tabs();
    this.user_details = get_user_details();
    this.fetch_event();
    this.fetch_event_types();
    this.fetch_recurring_types();
    this.get_all_tickets();

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);
  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
  },
  activated() {
    this.reset_manage_tabs();
  },
  beforeRouteUpdate(to, from, next) {
    this.reset_manage_tabs();
    next();
  },
  watch: {
    start_date(newVal, oldVal) { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    end_date(newVal, oldVal)   { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    start_time(newVal, oldVal) { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    end_time(newVal, oldVal)   { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    rsvp_start_date(newVal, oldVal) { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    rsvp_end_date(newVal, oldVal)   { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    tickets: {
      handler() {
        this.validate_all && this.validate_all();
        this.has_unsaved_changes = true;
      },
      deep: true,
    },
    extra_forms: {
      handler() {
        this.validate_all && this.validate_all();
        this.has_unsaved_changes = true;
      },
      deep: true,
    },
    show_extras_form() { this.has_unsaved_changes = true; },
    event_name(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    event_description(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    organizer(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    event_capacity(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    location(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    rsvp_start_time(newVal, oldVal) { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    rsvp_end_time(newVal, oldVal) { this.validate_all && this.validate_all(); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    is_free(newVal, oldVal) { this.$nextTick(() => { this.validate_all && this.validate_all(); }); if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    is_recurring(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    recurring_type(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
    cover_image(newVal, oldVal) { if (oldVal !== undefined && newVal !== oldVal) this.has_unsaved_changes = true; },
  },
  methods:{
     reset_manage_tabs() {
        this.active_manage_tab = DEFAULT_MANAGE_TAB;
        this.active_advanced_section = DEFAULT_ADVANCED_SECTION;
     },
    handle_realtime_event(event) {
      handle_manage_event_realtime(this, event);
    },
     set_manage_tab(tab) {
        if (!MANAGE_TABS.includes(tab)) return;

        this.active_manage_tab = tab;
        if (tab === "advanced") {
          this.active_advanced_section = DEFAULT_ADVANCED_SECTION;
        }
     },
     set_advanced_section(section) {
        if (!ADVANCED_SECTIONS.includes(section)) return;

        this.active_manage_tab = "advanced";
        this.active_advanced_section = section;
     },
     open_advanced_section() {
        const event = this.event;
        if (!this.event_id && !event?.id) return;

        switch (this.active_advanced_section) {
          case 'agenda':
            this.$refs.eventAgendaRef?.open_create_agenda?.(event);
            break;
          case 'speakers':
            this.$refs.eventSpeakerRef?.open_add_speakers?.(event);
            break;
          case 'survey':
            if (this.current_survey) {
              this.open_edit_survey(this.current_survey);
            } else {
              this.open_create_survey(event);
            }
            break;
          case 'photo_wall':
            this.$refs.eventMediaGalleryRef?.open_media_gallery_modal?.(event);
            break;
          case 'event_slides':
            this.$refs.eventResourceRef?.open_document_modal?.(event);
            break;
          case 'promo_codes':
            this.$refs.promoManagerRef?.open_promo_code_manager_modal?.(event);
            break;
          case 'sponsors':
            this.$refs.eventSponsorRef?.open_add_sponsors?.(event);
            break;
          default:
            break;
        }
     },
     is_non_empty(value) {
        return !!(value !== null && value !== undefined && String(value).trim());
     },
     normalize_optional_field(value) {
        if (value === null || value === undefined) return "";
        const normalized = String(value).trim();
        if (!normalized) return "";
        const lowered = normalized.toLowerCase();
        if (lowered === "null" || lowered === "undefined") return "";
        return normalized;
     },
     normalize_date_only(value) {
        const normalized = this.normalize_optional_field(value);
        if (!normalized) return "";
        return normalized.split("T")[0];
     },
     current_time_value() {
        const now = new Date();
        return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
     },
     later_date_value(firstDate, secondDate) {
        const first = this.normalize_date_only(firstDate);
        const second = this.normalize_date_only(secondDate);
        if (!first) return second;
        if (!second) return first;
        return first > second ? first : second;
     },
     event_end_date_min_value() {
        return this.later_date_value(this.today_date, this.start_date);
     },
     start_time_min_value() {
        return this.normalize_date_only(this.start_date) === this.today_date
          ? this.current_time_value()
          : null;
     },
     end_time_min_value() {
        const endDate = this.normalize_date_only(this.end_date);
        const startDate = this.normalize_date_only(this.start_date);

        if (endDate && startDate && endDate === startDate && this.start_time) {
          return this.start_time;
        }
        if (endDate === this.today_date) {
          return this.current_time_value();
        }
        return null;
     },
     rsvp_start_date_max_value() {
        return this.normalize_date_only(this.start_date) || null;
     },
     rsvp_start_time_min_value() {
        return null;
     },
     rsvp_start_time_max_value() {
        return (
          this.normalize_date_only(this.rsvp_start_date) &&
          this.normalize_date_only(this.rsvp_start_date) === this.normalize_date_only(this.start_date)
        )
          ? (this.start_time || null)
          : null;
     },
     rsvp_end_date_min_value() {
        return this.later_date_value(this.today_date, this.rsvp_start_date);
     },
     rsvp_end_date_max_value() {
        return this.normalize_date_only(this.start_date) || null;
     },
     rsvp_end_time_min_value() {
        const endDate = this.normalize_date_only(this.rsvp_end_date);
        const startDate = this.normalize_date_only(this.rsvp_start_date);

        if (endDate && startDate && endDate === startDate && this.rsvp_start_time) {
          return this.rsvp_start_time;
        }
        if (endDate === this.today_date) {
          return this.current_time_value();
        }
        return null;
     },
     rsvp_end_time_max_value() {
        return (
          this.normalize_date_only(this.rsvp_end_date) &&
          this.normalize_date_only(this.rsvp_end_date) === this.normalize_date_only(this.start_date)
        )
          ? (this.start_time || null)
          : null;
     },
     is_non_negative_number(value) {
        if (value === null || value === undefined) return false;
        const n = Number(value);
        return !Number.isNaN(n) && n >= 0;
     },
     is_positive_number(value) {
        if (value === null || value === undefined) return false;
        const n = Number(value);
        return !Number.isNaN(n) && n > 0;
     },
     clear_recurring_fields(event_data) {
        if (!event_data || typeof event_data !== "object") return event_data;

        return ({
          ...event_data,
          recurring_type: "",
          recurring_pattern: null,
          recurrence_pattern: null,
        });
     },
     normalize_is_recurring_value(event_data) {
        const recurring_flag = event_data?.is_recurring;
        const has_recurring_pattern = !!this.normalize_recurring_type_value(event_data);

        if (typeof recurring_flag === "string") {
          const normalized = recurring_flag.trim().toLowerCase();
          if (normalized === "true" || normalized === "1" || normalized === "yes") return true;
          if (normalized === "false" || normalized === "0" || normalized === "no") return false;
        }

        if (typeof recurring_flag === "number") {
          if (recurring_flag === 1) return true;
          if (recurring_flag === 0) return false;
        }

        if (typeof recurring_flag === "boolean") {
          return recurring_flag;
        }

        return has_recurring_pattern;
     },
     normalize_recurring_type_value(event_data) {
        const raw_value =
          event_data?.recurring_pattern?.recurring_pattern?.id ??
          event_data?.recurrence_pattern?.recurring_pattern?.id ??
          event_data?.recurring_pattern?.id ??
          event_data?.recurrence_pattern?.id ??
          event_data?.recurring_type?.id ??
          event_data?.recurrence_pattern ??
          event_data?.recurring_type ??
          "";

        if (raw_value === null || raw_value === undefined || raw_value === "") {
          return "";
        }

        const numeric_value = Number(raw_value);
        return Number.isNaN(numeric_value) ? raw_value : numeric_value;
     },
     validate_recurring_settings() {
        if (!this.is_recurring) {
          if (this.errors?.recurring_type) {
            delete this.errors.recurring_type;
          }
          this.recurring_type = "";
          return true;
        }

        if (!this.recurring_type) {
          this.errors = {
            ...this.errors,
            recurring_type: "Please select a recurrence pattern.",
          };
          return false;
        }

        if (this.errors?.recurring_type) {
          delete this.errors.recurring_type;
        }

        return true;
     },
     save_recurring_settings() {
        if (!this.validate_recurring_settings()) return;

        const current_event_id = this.event_id || this.event?.id || this.$route.params.event_id;
        if (!current_event_id) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "We could not find this event to save the recurring settings.",
            showConfirmButton: false,
            timer: 2000,
            position: "bottom-end",
            toast: true
          });
          return;
        }

        Swal.fire({
          title: "Saving recurring settings...",
          text: "Please wait while we update the recurring settings.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const formData = new FormData();
        formData.append("event_id", current_event_id);
        formData.append("is_recurring", this.is_recurring ? "true" : "false");
        formData.append("recurring_type", this.is_recurring ? this.recurring_type : "");

        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_recurring/`,
          data: formData,
          processData: false,
          contentType: false,
          headers: {
            Authorization: `Token ${this.get_auth_token()}`,
          },
          success: (response) => {
            if (response.status === "success") {
              this.event = response.event || {
                ...(this.event || {}),
                id: current_event_id,
                is_recurring: this.is_recurring,
                recurring_type: this.is_recurring ? this.recurring_type : "",
              };
              if (!this.is_recurring) {
                this.event = this.clear_recurring_fields(this.event);
              }
              this.is_recurring = this.normalize_is_recurring_value(this.event);
              this.recurring_type = this.is_recurring
                ? this.normalize_recurring_type_value(this.event)
                : "";
              this.event_id = this.event?.id || current_event_id;
              this.has_unsaved_changes = false;
              Swal.fire({
                icon: "success",
                title: "Success",
                text: response.message || "Recurring settings saved successfully.",
                showConfirmButton: false,
                timer: 2000,
                position: "bottom-end",
                toast: true
              });
            }
          },
          error: (xhr) => {
            Swal.close();
            Swal.fire({
              icon: "error",
              title: "Error",
              text: xhr?.responseJSON?.message || xhr?.responseJSON?.error || "An error occurred while saving the recurring settings, please try again.",
              showConfirmButton: false,
              timer: 2000,
              position: "bottom-end",
              toast: true
            });
          },
        });
     },
     is_ticket_date_range_ok(start_date, end_date) {
        if (!this.is_non_empty(start_date) || !this.is_non_empty(end_date)) return false;
        // Both dates are in ISO-ish `YYYY-MM-DDTHH:mm` format, so string compare is safe.
        return String(end_date) >= String(start_date);
     },
     ticket_sale_max_datetime() {
        if (!this.is_non_empty(this.start_date) || !this.is_non_empty(this.start_time)) return null;
        return `${this.start_date}T${this.format_time_hhmm(this.start_time)}`;
     },
     ticket_sale_end_min_datetime(ticket) {
        const baseMin = String(this.min_datetime || "");
        const ticketStart = String(ticket?.start_date || "").trim();
        if (!ticketStart) return baseMin || null;
        if (!baseMin) return ticketStart;
        return ticketStart > baseMin ? ticketStart : baseMin;
     },
     is_valid_ticket(ticket) {
        const validators = [
          (t) => this.is_non_empty(t?.name),
          (t) => this.is_non_negative_number(t?.price),
          (t) => this.is_positive_number(t?.quantity),
          (t) => this.is_non_empty(t?.start_date),
          (t) => this.is_non_empty(t?.end_date),
          (t) => this.is_ticket_date_range_ok(t?.start_date, t?.end_date),
        ];
        return validators.every((fn) => fn(ticket));
     },
     get_speaker_initials(speaker) {
        const first = String(speaker?.first_name || '').trim();
        const last = String(speaker?.last_name || '').trim();
        const a = first ? first[0].toUpperCase() : '';
        const b = last ? last[0].toUpperCase() : '';
        return (a + b) || '?';
     },
     open_view_speakers() {
        this.$refs.eventSpeakerRef?.open_view_speakers?.(this.event);
     },
     open_view_agenda() {
        this.$refs.eventAgendaRef?.open_view_agenda?.(this.event);
     },
     open_view_sponsors() {
        this.$refs.eventSponsorRef?.open_view_sponsors?.(this.event);
     },
     open_create_survey(event) {
        this.$refs.eventSurveyRef?.open_create_survey?.(event);
     },
     open_edit_survey(survey) {
        this.$refs.eventSurveyRef?.open_edit_survey?.(survey);
     },
     open_view_survey(survey) {
        this.$refs.eventSurveyRef?.open_view_survey?.(survey);
     },
     delete_survey(survey_id) {
        this.$refs.eventSurveyRef?.delete_survey?.(survey_id);
     },
     format_time_hhmm(timeStr) {
        const t = String(timeStr || '').trim();
        if (!t) return '';
        return t.length >= 5 ? t.slice(0, 5) : t;
     },
     get_event_media_files() {
        const files =this.event?.event_files;
        return files?.filter((file) => String(file?.event_file_type?.name || '').toLowerCase() === 'event gallery');
     },
     get_event_resource_files() {
        const files =this.event.event_files;
        return files.filter((file) => String(file?.event_file_type?.name || '').toLowerCase() === 'event resources');
     },
     get_file_name(item) {
        return this.$refs.eventResourceRef?.get_file_name?.(item) || 'Document';
     },
     get_file_type_label(item) {
        return this.$refs.eventResourceRef?.get_file_type_label?.(item) || 'Document';
     },
     get_document_icon(item) {
        return this.$refs.eventResourceRef?.get_icon_class?.(item) || '';
     },
     promo_discount_label(promo) {
        const typeName =
          String(promo?.promo_code_type?.name || promo?.promo_code?.promo_code_type?.name || '').toLowerCase();
        const amount = promo?.discount_amount ?? promo?.promo_code?.discount_amount;
        if (typeName.includes('percentage')) return `${amount}% off`;
        return `R${amount} off`;
     },
    promo_usage_label(promo) {
       const used = promo?.usage_count;
       const limit = promo?.usage_limit;
       if (limit) return `${used} / ${limit} used`;
       return `${used} used`;
    },
    format_sponsor_url(url) {
       const raw = String(url || '').trim();
       if (!raw) return '';
       if (/^https?:\/\//i.test(raw)) return raw;
       return `https://${raw}`;
    },
    sponsor_href(url) {
      return this.format_sponsor_url(url);
    },
    upsert_by_id(list, item) {
       const next = Array.isArray(list) ? [...list] : [];
       const id = item?.id;
       if (id === null || id === undefined) return next;
       const idx = next.findIndex((x) => String(x?.id) === String(id));
       if (idx === -1) next.unshift(item);
       else next.splice(idx, 1, item);
       return next;
    },
    remove_by_id(list, id) {
       const arr = Array.isArray(list) ? list : [];
       return arr.filter((x) => String(x?.id) !== String(id));
    },
    on_media_updated(items) {
       const arr = Array.isArray(items) ? items : [];
       arr.forEach((it) => {
         this.photo_wall_media = this.upsert_by_id(this.photo_wall_media, it);
       });
    },
    on_media_deleted(id) {
       this.photo_wall_media = this.remove_by_id(this.photo_wall_media, id);
    },
    on_documents_updated(items) {
       const arr = Array.isArray(items) ? items : [];
       arr.forEach((it) => {
         this.event_slides_documents = this.upsert_by_id(this.event_slides_documents, it);
       });
    },
    on_document_deleted(id) {
       this.event_slides_documents = this.remove_by_id(this.event_slides_documents, id);
    },
    on_gallery_visibility_updated(value) {
       this.public_gallery = !!value;
       if (this.event) {
         this.event.public_gallery = !!value;
       }
    },
    on_slides_visibility_updated(value) {
       this.public_slides = !!value;
       if (this.event) {
         this.event.public_slides = !!value;
       }
    },
    on_promo_updated(promo) {
       if (!promo?.id || !this.event) return;

       this.event_promos = this.upsert_by_id(this.event_promos, promo);

       if (!Array.isArray(this.event.promo_codes)) this.event.promo_codes = [];
       this.event.promo_codes = this.upsert_by_id(this.event.promo_codes, promo);
    },
    on_promo_deleted(id) {
       if (!this.event) return;
       this.event_promos = this.remove_by_id(this.event_promos, id);
       if (Array.isArray(this.event.promo_codes)) {
         this.event.promo_codes = this.remove_by_id(this.event.promo_codes, id);
       }
    },
    on_survey_updated(survey) {
       const s = survey && typeof survey === 'object' ? survey : null;
       if (!s?.id || !this.event) return;

       if (!Array.isArray(this.event.survey)) this.event.survey = [];
       const idx = this.event.survey.findIndex((x) => (x?.survey?.id || x?.id) === s.id);
       const wrapper = { survey: s };
       if (idx === -1) this.event.survey.unshift(wrapper);
       else this.event.survey.splice(idx, 1, wrapper);
    },
    on_survey_deleted(survey_id) {
       if (!this.event || !Array.isArray(this.event.survey)) return;
       const id = Number(survey_id);
       this.event.survey = this.event.survey.filter((x) => Number(x?.survey?.id || x?.id) !== id);
     },
     on_agenda_updated(payload) {
        if (!payload?.agenda || !this.event) return;
        const nextAgenda = payload.agenda;
        if (Array.isArray(nextAgenda?.agenda)) {
          this.event.agenda = nextAgenda.agenda;
        }
        if (Array.isArray(nextAgenda?.files)) {
          const keepFiles = Array.isArray(this.event.event_files)
            ? this.event.event_files.filter((f) => String(f?.event_file_type?.name || '').toLowerCase() !== 'agenda')
            : [];
          this.event.event_files = [...nextAgenda.files, ...keepFiles];
        }
     },
    get_user_id() {
       return this.user_details?.user_id;
    },
     get_auth_token() {
        return get_token()
     },
    fetch_event() {
        if (!this) return;
        const event_id = this.$route.params.event_id;
        if (!event_id) {
            this.error_message = "Missing event id.";
            this.is_loading = false;
            return;
        }
        this.is_loading = true;
        this.error_message = "";
        const user_id = this.get_user_id();

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event/`,
            contentType: "application/json",
            method: "POST",
             headers: {
            'Authorization': `Token ${this.get_auth_token()}`,
            'Content-Type': 'application/json'
            },
            data: JSON.stringify({ event_id: Number(event_id), user_id }),
            success: (response) => {
            if (response?.status === "success") {
                this.event = response.event;
                this.event_id = response?.event?.id ?? Number(event_id);
                this.selected_event = response.event;
                const tickets = Array.isArray(response?.event?.event_tickets)
                ? response.event.event_tickets
                : [];
                this.event_tickets = tickets.map((ticket) => ({
                ...ticket,
                quantitySelected: 0
                }));
            } else {
                this.error_message = response?.message || "Failed to load event.";
            }
            },
            error: (xhr) => {
            this.error_message = xhr?.responseJSON?.message || "Failed to load event.";
            },
            complete: () => {
            this.is_loading = false;
            this.set_event_values()
            }
        });
     },
  fetch_event_types() {
      this.is_loading = true;
      this.token_exists = this.get_auth_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_types/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.get_auth_token()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.event_types = response.data.event_type;
          this.event_types = this.event_types.map(type => {
            if (type.name === 'in_person') {
              return { ...type, name: 'in person' };
            }
            return type;
          });
          const default_type = this.event_types.find(t => t.name === 'in person'   );

          if (default_type) {
            this.event_type = default_type;
          }
        },
        complete: () => {
          this.is_loading = false;
        },
      });
    },
  fetch_recurring_types() {
      this.is_loading = true;
      this.token_exists = this.get_auth_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_recurring_pattern/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.get_auth_token()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.recurring_patterns = response.data.recurring_patterns;
        },
        complete: () => {
          this.is_loading = false;
        },
      });
    },
    get_all_tickets() {
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_tickets_type/`,
        headers: {
          Authorization: `Token ${this.get_auth_token()}`
        },
        success: (response) => {

          this.all_tickets = response.tickets || [];
        },
      });
    },
  set_event_values(){
       this.event_name= this.event.event_name;
        this.location= this.event.location;
        this.is_recurring = this.normalize_is_recurring_value(this.event);
        this.recurring_type = this.normalize_recurring_type_value(this.event);
        this.event_type = {...this.event.event_type,
          name: this.event.event_type.name === "in_person" ? "in person" : this.event.event_type.name
        };
        this.event_description = this.event.description;
        const TextDescription = this.event.description?.replace(/<[^>]*>/g, "");
        this.$nextTick(() => {
          if (this.$refs.quillEventEditorRef) {
            const quillEditor = this.$refs.quillEventEditorRef.getQuill();
            if (quillEditor) {
              quillEditor.setContents([
                { insert: TextDescription || "" },
              ]);
            }
          }
        });
        if(this.event.rsvp_cap){
          this.event_capacity= this.event.rsvp_cap.rsvp_max_capacity;
        }
        this.event_link = this.event.event_link;
        this.end_date = this.event.end_date;
        this.end_time = this.event.end_time;
        this.start_date = this.event.start_date;
        this.start_time = this.event.start_time;
        this.is_free = this.event.is_free;
        this.public_gallery = this.event.public_gallery !== false;
        this.public_slides = this.event.public_slides !== false;
        if (this.is_free) {
          this.rsvp_start_date = this.normalize_optional_field(this.event.rsvp_start_date);
          this.rsvp_start_time = this.normalize_optional_field(this.event.rsvp_start_time);
          this.rsvp_end_date = this.normalize_optional_field(this.event.rsvp_end_date);
          this.rsvp_end_time = this.normalize_optional_field(this.event.rsvp_end_time);
        } else {
          this.rsvp_end_date = this.normalize_optional_field(this.event.rsvp_end_date);
          this.rsvp_start_time = this.normalize_optional_field(this.event.rsvp_start_time);
          this.rsvp_start_date = this.normalize_optional_field(this.event.rsvp_start_date);
          this.rsvp_end_time = this.normalize_optional_field(this.event.rsvp_end_time);
        }
        this.organizer = this.event.user.first_name.charAt(0).toUpperCase() + this.event.user.first_name.slice(1);
        this.cover_image_preview = this.event.cover_image || null;
         this.tickets = this.event.event_tickets.map((ticket) => ({
           name: ticket.ticket.name,
           end_date: ticket.end_date.substring(0, 16),
           price: ticket.price,
           quantity: ticket.quantity,
           start_date: ticket.start_date.substring(0, 16),
         }));

        if (this.event.event_extras && this.event.event_extras.length > 0) {
          this.show_extras_form = true;
          this.extra_forms = this.event.event_extras.map(extra => ({
            id: extra.extra.id,
            selectedExtra: extra.extra ? extra.extra.name : '',
            items: extra.items.map(item => ({
              id: item.id,
              item_name: item.item_name,
              item_description: item.description,
              item_price: item.price || 0
            }))
          }));
        } else {
          this.show_extras_form = false;
        }

       let event_file = this.event?.event_files?.find(file => file.event_file_type.name === 'event_profile')
       this.cover_image_preview = event_file?.file?.file_url || ''
     // run full validation (dates + tickets) after populating values so UI shows any errors.
     this.$nextTick(() => {
       this.validate_all && this.validate_all();
       this.has_unsaved_changes = false;
     });
    },
  ...helpers,
    trigger_upload() {
      this.$refs.fileInput.click();
    },
    update_event() {
        Swal.fire({
          title: "Updating...",
          text: "Please wait while we update the event.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const formData = new FormData();
        formData.append("event_id", this.event_id);
        formData.append("event_name", this.event_name);
        this.event_description = this.$refs.quillEventEditorRef.getHTML();
        formData.append('description', this.event_description);
        formData.append("start_date", this.start_date);
        formData.append("start_time", this.start_time);
        formData.append("end_date", this.end_date);
        formData.append("end_time", this.end_time);
        if(this.event_capacity>0){
          formData.append("rsvp_max_capacity", this.event_capacity);
        }
       if(this.is_free){
        const appendIfValue = (key, value) => {
          if (value !== null && value !== undefined && value !== "") {
            formData.append(key, value);
          }
        };
        appendIfValue("rsvp_start_date", this.rsvp_start_date);
        appendIfValue("rsvp_start_time", this.rsvp_start_time);
        appendIfValue("rsvp_end_date", this.rsvp_end_date);
        appendIfValue("rsvp_end_time", this.rsvp_end_time);
        }
        formData.append("organizer", this.organizer);
        formData.append('is_free', this.is_free ? "true" : "false");
        if(this.tickets.length >0){
        const ticketsPayload = this.tickets.map(t => ({
          ticket_name: t.name,
          price: t.price,
          quantity: t.quantity,
          start_date: t.start_date,
          end_date: t.end_date,
        }));
        if(!this.is_free){
          formData.append('tickets', JSON.stringify(ticketsPayload));
        }
      }
        const extras_data = [];
        this.extra_forms.forEach(extra => {
          if (extra.selectedExtra && extra.selectedExtra.trim()) {
            const validItems = [];
            extra.items.forEach(item => {
              if (item.item_name && item.item_name.trim()) {
                validItems.push({
                  id: item.id,
                  item_name: item.item_name.trim(),
                  description: item.item_description?.trim(),
                  price: item.item_price || 0
                });
              }
            });
            if (validItems.length > 0) {
              extras_data.push({
                id: extra.id,
                extra_name: extra.selectedExtra,
                items: validItems
              });
            }
          }
        });

        if (extras_data.length > 0) {
          formData.append("extra", JSON.stringify(extras_data));
        }
        if (this.cover_image) {
          formData.append("file", this.cover_image);
        }
        if(this.event_capacity>0){
          formData.append('rsvp_max_capacity', this.event_capacity);
        }
        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/update_event_api/`,
          data: formData,
          processData: false,
          contentType: false,
          headers: {
            Authorization: `Token ${this.get_auth_token()}`,
          },
          success: (response) => {
            if (response.status === "success") {
              this.event = response.event;
              this.has_unsaved_changes = false;
              Swal.fire({
                icon: "success",
                title: "Success",
                text: response.message,
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              });
            }
          },
          error: () => {
            Swal.close();
            Swal.fire({
              icon: "error",
              title: "Error",
              text: 'An error occurred while trying to update the Event, please try again.',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            });
          },
        });
      },
    publish_event (){
      let data= {"event_id": this.event_id || this.event?.id || this.$route.params.event_id}
       $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/toggle_published_event/`,
          data: JSON.stringify(data),
          processData: false,
          contentType: "application/json",
          headers: {
            Authorization: `Token ${this.get_auth_token()}`,
          },
          success: (response) => {
            if (response.status === "success") {
              this.event.is_published = response?.is_published;
              Swal.fire({
                icon: "success",
                title: "Success",
                text: response.message,
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              });
            }
          },
          error: () => {
            Swal.close();
            Swal.fire({
              icon: "error",
              title: "Error",
              text: 'An error occurred while trying to update the Event, please try again.',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            });
          },
        });
    }
  }
}
